import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { login, 
    // verifyRecaptcha 
} from '../../actions/authAction';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
// import { toast } from "react-toastify";
import * as Yup from "yup";
// import axios from 'axios';
import { useFormik } from 'formik';
// import ReCAPTCHA from "react-google-recaptcha";
import './style.css'
import logo from '../../assets/icons/MetaBrief_horizontal_RBG.jpg'
import { VALIDATE_EMAIL, VALIDATE_PASSWORD } from '../../constants/constants'

const Login = () => {
    
    const { loading } = useSelector(state => state.auth)
    const history = useHistory();
    const dispatch = useDispatch();
    // const recaptchaRef = React.createRef();
    const [viewPassword, setViewPassword] = useState('password')
    // const [isVerified, setVerifyCaptcha] = useState(true);
    const formik = useFormik({
        initialValues: {
            password: '',
            email: '',
            rememberMe: false
        },
        validationSchema: Yup.object({
            email: Yup.string().required('Email is required').matches(VALIDATE_EMAIL, "Email is not valid"),
            password: Yup.string().max(12, 'Must be 12 characters or less').min(6, 'Must be 6 characters or more').required('Please Enter your password')
                .matches(VALIDATE_PASSWORD, "Must contain 6 characters, one uppercase, one lowercase, one number and one special case character"),
            rememberMe: Yup.boolean()
        }),
        onSubmit: (value, { resetForm }) => { 
            dispatch(login(value, history));
            // isVerified && dispatch(login(value, history));
            // !isVerified && toast.error("ReCAPTCHA Not verify");

            //resetForm();
        },
    });

    // function onChange(value) {
    //     let response = { value: value }
    //     return verifyRecaptcha(response)
    //         .then((result)=>setVerifyCaptcha(result?.data?.data?.success))
    // }
    const handleClick = (e) => {
        e.preventDefault();
        const passwordStatus = viewPassword === 'password' ? 'text' : 'password'
        console.log(passwordStatus);
        setViewPassword(passwordStatus);
    }

    return (
        <div id="wrapper" className="au th-main">
            <div className="container">
                <div className="row clearfix">
                    {/* <div className="col-12">
                        <nav className="navbar navbar-expand-lg">
                            <span className="navbar-brand" ><img src={logo} width="130" height="40" className="d-inline-block align-top mr-2" alt="" /></span>
                           
                        </nav>
                    </div> */}
                    <div className="col-md-4 mx-auto">
                        <div className="card custom_card border-radius-10">
                        <div className="header text-center pb-0">
                        <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>

                            <h4 className='login_text'><strong>Login</strong></h4>
                            </div>
                            {/* {error && <Error error={error} />} */}
                            <div className="body">
                                <form className="form-auth-small p-0" onSubmit={formik.handleSubmit}>
                                    <div className="form-group relative_pos">
                                        <label htmlFor="signin-email" className="control-label sr-only">Email</label>
                                        <span className='text_icon_input'><i className="icon-user"></i></span>
                                        <input type="text" name="email" {...formik.getFieldProps('email')} className="custom_form_new form-control" placeholder="Email" required />
                                        {formik.touched.email && formik.errors.email ? (
                                            <div className="text-danger">{formik.errors.email}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group relative_pos">
                                        <label htmlFor="signin-password" className=" control-label sr-only">Password</label>
                                        <div className='pass-wrapper'>
                                        <span className='text_icon_input'><i className="icon-lock"></i></span>
                                            <input name="password" type={viewPassword} {...formik.getFieldProps('password')} className="  custom_form_new form-control" placeholder="Password" required />
                                            <span className="password__show" onClick={handleClick}>{viewPassword === 'text' ? <i className='fa fa-eye eyeIcon'></i> : <i className='eyeIcon fa fa-eye-slash'></i>}</span>
                                        </div>
                                        {formik.touched.password && formik.errors.password ? (
                                            <div className="text-danger">{formik.errors.password}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group clearfix">
                                        <div className='row'>
                                            <div className='col'>
                                        <label className="fancy-checkbox element-left">
                                            <input type="checkbox" name="rememberMe" {...formik.getFieldProps('rememberMe')} />
                                            <span>Remember me</span>
                                            </label>
                                            </div>
                                            <div className='col push-right'>                                        
                                       <span className="helper-text m-b-10 "><Link to="/forgot-password" className="p-1">Forgot password?</Link></span>
</div>
                                        
                                        </div>
                                    </div>
                                    {/* <ReCAPTCHA
                                        sitekey="6LfutyweAAAAAHEV5lBfIMnN8Lhb4Bw0bG84e6P3"
                                        render="explicit"
                                        onChange={onChange}
                                    /> */}
                                    <button type="submit" className="btn button btn-lg btn-block" disabled={loading ? true : false}>Log in</button>
                                    <div className="bottom mt-4 text-center">
                                        <span>Don't have an account? <Link to="/register">Register</Link></span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Login;